import axios from 'axios'
 
export default {
   request: (method, uri, headers = null , params = null , data = null) => {
        if (method == undefined) {
            return "Please provide method to make api call"
        } else if(uri == undefined) {
            return "Please provide url"
        } else {
            return axios({method: method, url: uri, headers: headers, params: params, data: data})
        }
    }
}